// generated from 3_011 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const emailOptInSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("email_opt_in_since_filter"),
  comparison_key: z.enum([
    "4", // 2_393 (79.48%)
    "3", // 331 (10.99%)
    "6", // 267 (8.87%)
    "5", // 20 (0.66%)
  ]),
  display_name: z.string(),
  // undefined: 2_666 (88.54%), defined 345 (11.46%)
  raw_value: z
    .union([
      // number samples: 261 (75.65%)
      // integer: 250 (95.79%)
      // avg: 24.82, min: 0, max: 180
      z.number().min(0),
      // string samples: 84 (24.35%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 2_660 (88.34%)
    // integer: 2_647 (99.51%)
    // avg: 45.22, min: 0, max: 365
    z.number().min(0),
    // string samples: 351 (11.66%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
